type HalmWindow = Window &
  typeof globalThis & {
    getHalmParametersQueryString?: () => string;
  };

const FORWARDED_QUERY_PARAMETERS = [
  "customer_group",
  "last_date_of_fertilization",
  "moss",
  "weeds",
  "organic",
];

export const readHalmParametersQueryString = () => {
  const halmWindow = window as HalmWindow;
  const params = new URLSearchParams(
    halmWindow.getHalmParametersQueryString?.() ?? "",
  );
  const currentUrlParams = new URLSearchParams(window.location.search);

  FORWARDED_QUERY_PARAMETERS.forEach((key) => {
    const value = currentUrlParams.get(key);

    if (value && !params.has(key)) {
      params.set(key, value);
    }
  });

  return params.toString();
};

export const readBooleanHalmParameter = (key: string) => {
  const params = new URLSearchParams(readHalmParametersQueryString());
  return params.get(key) === "true";
};
